// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"177dfbd6","104":"10ed4669","133":"e6fcf43c","418":"74a4dcea","453":"f82db826","695":"d8eba328","737":"a23885ae","857":"81c1bd7b"}[chunkId] + ".chunk.js";
};